import React from "react";

const Button = (props) => {
  return props.text === "Add another" || props.text === "Add movie" ? (
    <button className="btn btn-light btn-add" onClick={(e) => props.onClick(e)}>
      {props.text}
    </button>
  ) : props.text === "Save" ? (
    <button className="btn btn-dark btn-save" onClick={(e) => props.onClick(e)}>
      {props.text}
    </button>
  ) : props.text === "Search" ? (
    <button
      className="btn btn-dark btn-search"
      onClick={(e) => props.onClick(e)}
    >
      {props.text}
    </button>
  ) : props.text === "View Library" ? (
    <button
      className="btn btn-dark btn-view-lib"
      onClick={(e) => props.onClick(e)}
    >
      {props.text}
    </button>
  ) : props.text === "Edit" ? (
    <button className="btn btn-dark btn-edit" onClick={(e) => props.onClick(e)}>
      {props.text}
    </button>
  ) : props.text === "Profile" ? (
    <button className="btn btn-dark" onClick={props.onClick}>
      {props.text}
    </button>
  ) : (
    <button className="btn btn-dark" onClick={(e) => props.onClick(e)}>
      {props.text}
    </button>
  );
  //must be able to pass down props/state for different wording in respective components
  //Navbar.js: "Profile"
  //optional Movies.js: "Search"
  //Profile Entry/Creation state: "Save"
  //Profile Saved state: "Edit your profile"
  //Profile Editing state: "Save"
};

//in dev shop, ls re: buttons - background color can be passed in and inline styling for padding.

//export component so other JS files can find this component
export default Button;
